import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="border-y border-line bg-canvasAlt" data-id="element-56" data-mp="2bju8fjocf3ie">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-14" data-id="element-57" data-mp="2flxv74ggpuiz">
        <Reveal data-id="element-58" data-mp="2fl5ytrf1jsrn">
          <SectionHeading id="faq" title="Preguntas frecuentes" data-id="element-59" data-mp="2fns6rs5ugaae" />
        </Reveal>

        <div className="mt-8 grid gap-2" data-id="element-60" data-mp="21sgdzqb90tw4">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="rounded-2xl border border-line bg-surface" data-id="element-61" data-mp="2uiomeqfzfzxi" data-mpi={i}>
                <h3 data-id="element-62" data-mp="2zbhrjffd5aa4">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-63" data-mp="2zc1cl50b8esd">
                    <span className="text-sm md:text-base font-semibold text-ink" data-id="element-64" data-mp="20ocfj8t83ugn">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={18} className={`flex-shrink-0 text-gold transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-65" data-mp="2fbxdypf5l5i8" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-66" data-mp="2jdiymwxxio2z">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-67" data-mp="u0nu2ebotwej">
                      <p className="px-5 pb-4 text-sm leading-relaxed text-ink-muted" data-id="element-68" data-mp="2z06tvipxcclu">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}